import React from "react";
import type { IBadgeCategories } from "types/insights/product-badges";
import { format } from "lib/globalize-util";
import Badge from "./badge";

interface ITopProductBadge {
    productBadges: IBadgeCategories;
}

const TopProductBadge: React.FC<ITopProductBadge> = ({ productBadges }) => {
    const name = format("Top product");
    const tooltipTitle = format("Order Trends");
    const tooltipTextList = Object.entries(productBadges)
        .filter(([category]) => category === "immediate" || category === "prebook")
        .map(([category, details]) =>
            format(
                `#${details.rank} ${category === "immediate" ? "Immediate" : "Prebook"} product in USD orders within the last ${category === "immediate" ? "six" : "three"} months`,
            ),
        );

    return <Badge name={name} tooltipTitle={tooltipTitle} tooltipTextList={tooltipTextList} />;
};

export default TopProductBadge;
